import { http } from '@/core/helpers/http.helper';
import { Module } from './../../modules/module.interface';
export class ModuleService {
   async getModules(tenantId: number) {
      const response = await http.get<Array<Module>>(`/tenants/${tenantId}/modules`);
      return response.data;
   }
   async postModulesBatch(tenantId: number, modules: Array<Module>) {
      const response = await http.post<Array<Module>>(`/tenants/${tenantId}/modules-batch`, { modules });
      return response.data;
   }

   async deleteModulesBatch(tenantId: number, modules: Array<Module>) {
      const response = await http.delete<Array<Module>>(`/tenants/${tenantId}/modules-batch`, { data: { modules } });
      return response.data;
   }
   async getModule() {
      throw Error('Method not implemented');
   }

   async postModule() {
      throw Error('Method not implemented');
   }

   async putModule() {
      throw Error('Method not implemented');
   }

   async deleteModule() {
      throw Error('Method not implemented');
   }
}
